<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.question, decisionTree.context)" />
    </template>

    <template #body>
      <BaseTileGrid>
        <BaseTileGridItem type="radio">
          <BaseRadioButton v-model="node.selectedPatientType" value="returning" :label="node.returningChoiceText" />
        </BaseTileGridItem>
        <BaseTileGridItem type="radio">
          <BaseRadioButton v-model="node.selectedPatientType" value="new" :label="node.newChoiceText" />
        </BaseTileGridItem>
      </BaseTileGrid>
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "../../composables/useSnippetProcessor";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const { processText } = useSnippetProcessor();
</script>
